import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useNetworksService } from '@/flight-deck-api/services/networks.service'

/**
 * Hook for fetching available networks
 * @returns Networks data, loading state, and errors
 */
export const useNetworks = () => {
  const { getNetworks } = useNetworksService()

  const {
    data: networksResponse,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['networks'],
    // biome-ignore lint/plugin: RETIRED, do not copy. Call it through useSelectQuery/useSelectMutation when touching this.
    queryFn: () => getNetworks.handler(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  })

  const networks = useMemo(
    () =>
      networksResponse?.data?.map(network => ({
        id: String(network.networkId),
        name: network.name,
      })) || [],
    [networksResponse],
  )

  return {
    networks,
    isLoading,
    error,
    refetch,
  }
}
